import { createBrowserHistory, createMemoryHistory } from "history";

import CONFIG from "./config";
import { console } from "./utils/functions";

let createHistory = createBrowserHistory;
if (CONFIG.VERSE_NEO) {
  createHistory = createMemoryHistory;
}
const contextRoot = CONFIG.CONTEXT_ROOT;
const history = createHistory({ basename: contextRoot });
if (CONFIG.NODE_ENV === "Xdevelopment") {
  history.listen(({ location, action }) => {
    if (String(location.hash).match(/^#!$/)) {
      console.log("The current URL is ", location);
      console.log(`The last navigation action was ${action}`, JSON.stringify(history, null, 2));
    }
  });
}
export default history;
